module.exports = __webpack_public_path__ + "fonts/lato-bold-webfont.dc7cf3e6.woff2";